export class User {
  id = 0
  username = '';
  role = '';
  token = '';
  mustChangePassword = false;
  password?: string;

  static parseJson(json: any): User {
    if (json === null || json === undefined) {
      return null;
    }
    return Object.assign(new User(), json);
  }
}
